import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SortingNames, SortingOrder } from '../../common.constants';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
})
export class FiltersComponent {
  @Input() set activeFilters(f) {
    this.searchStrSaved = f.search;
    this.searchStr = f.search;

    this.sortOrder = f.sort.order;
    this.sortBy = f.sort.by;
    this.activeOption = f.sort.by + '_' + f.sort.order;
  }

  @Output() searchChange = new EventEmitter();
  @Output() sortingChange = new EventEmitter();

  visibleSearch = false;
  visibleOptions = false;
  searchStrSaved;
  searchStr;

  activeOption;
  sortOrder;
  sortBy;
  sortingOrder = SortingOrder;

  options = [
    {
      title: 'Newest first',
      id: SortingNames.DATE + '_' + SortingOrder.ASC,
    },
    {
      title: 'Oldest first',
      id: SortingNames.DATE + '_' + SortingOrder.DESC,
    },
    {
      title: 'By Name A-Z',
      id: SortingNames.NAME + '_' + SortingOrder.ASC,
    },
    {
      title: 'By Name Z-A',
      id: SortingNames.NAME + '_' + SortingOrder.DESC,
    },
  ];

  clearSearch() {
    this.searchStr = '';
  }

  selectOption(opt) {
    this.visibleOptions = false;
    if (this.activeOption === opt) {
      return;
    }
    const arr = opt.split('_');
    this.sortingChange.emit({
      by: arr[0],
      order: arr[1],
    });
  }

  toggleOptions() {
    if (this.visibleSearch) {
      this.toggleSearch();
    }
    this.visibleOptions = !this.visibleOptions;
  }

  toggleSearch() {
    if (this.visibleOptions) {
      this.visibleOptions = false;
    }
    this.visibleSearch = !this.visibleSearch;
    if (!this.visibleSearch && this.searchStrSaved !== this.searchStr) {
      this.searchChange.emit(this.searchStr);
    }
  }
}
